/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ckbox
 */

export { default as CKBox } from './ckbox';
export { default as CKBoxEditing } from './ckboxediting';
export { default as CKBoxUI } from './ckboxui';
